import React from "react";
import { Hourglass, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import Background from "@/components/Background";

const PendingApproval = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen relative overflow-hidden">
      <Background />
      <div className="relative z-10 min-h-screen flex items-center justify-center px-6">
        <div className="max-w-md w-full bg-card/80 backdrop-blur-xl border border-black/5 dark:border-white/10 rounded-3xl p-10 text-center space-y-5 shadow-2xl">
          <div className="inline-flex w-14 h-14 rounded-2xl bg-amber-500/10 items-center justify-center text-amber-500 mx-auto">
            <Hourglass size={28} weight="duotone" />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Access request</p>
            <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight mt-2">
              Your account is pending approval
            </h1>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Thanks for signing in as <strong className="text-foreground">{user?.email}</strong>.
            An administrator needs to approve your account before you can access the
            client database. This usually takes a few minutes during business hours.
          </p>
          <p className="text-xs text-muted-foreground">
            Contact your team lead if this is taking longer than expected.
          </p>
          <Button
            onClick={logout}
            variant="outline"
            className="rounded-full h-11 w-full"
            data-testid="pending-logout"
          >
            <SignOut size={16} className="mr-1.5" /> Sign out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
